import client from "./client";
import { useMutation, useQuery } from "@tanstack/react-query";

import { useNotifications } from "reapop";
import { queryClient } from "queryclient";
import { useNavigate } from "react-router-dom";

export const AllSynthesisMutation = () => {
  const allSynthesis = useQuery({
    queryKey: ["get-all-synthesis"],
    queryFn: () => client.synthesis.allSynthesis(),
  });
  return allSynthesis;
};

export const AddSynthesisMutation = () => {
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const addSynthesis = useMutation({
    mutationFn: (data) => client.synthesis.addSynthesis(data),
    onSuccess: () => {
      notify("Details Added Successfully", "success");
      queryClient.invalidateQueries({
        queryKey: ["get-all-synthesis"],
      });
      navigate("/all-synthesis");
    },
    onError: () => {
      notify("OOPS! some error occured", "error");
    },
  });
  return addSynthesis;
};

export const SingleSynthesisMutation = (data) => {
  const singleSynthesis = useQuery({
    queryKey: ["get-single-synthesis"],
    queryFn: () => client.synthesis.singleSynthesis(data),
  });
  return singleSynthesis;
};

export const EditSynthesisMutation = () => {
  const { notify } = useNotifications();
  const navigate = useNavigate();
  const editSynthesis = useMutation({
    mutationFn: (data) => client.synthesis.editSynthesis(data),
    onSuccess: () => {
      notify("Details Edited Successfully", "success");
      queryClient.invalidateQueries({
        queryKey: ["get-all-synthesis"],
      });
      navigate("/all-synthesis");
    },
    onError: () => {
      notify("OOPS! some error occured", "error");
    },
  });
  return editSynthesis;
};

export const DeleteSynthesisMutation = () => {
  const { notify } = useNotifications();
  const deleteSynthesis = useMutation({
    mutationFn: (data) => client.synthesis.deleteSynthesis(data),
    onSuccess: () => {
      notify("Details Deleted Successfully", "success");
      queryClient.invalidateQueries({
        queryKey: ["get-all-synthesis"],
      });
    },
    onError: () => {
      notify("OOPS! some error occured", "error");
    },
  });
  return deleteSynthesis;
};

export const GetSynthExploreHeading = () => {
  return useQuery({
    queryKey: ["get-synth-explore-heading"],
    queryFn: () => client.synthesis.getSynthExploreHeading(),
  });
};

export const UpdateSynthExploreHeading = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.synthesis.updateSynthExploreHeading(data),
    onSuccess: () => {
      notify("Heading updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-synth-explore-heading"] });
    },
    onError: () => notify("OOPS! something went wrong", "error"),
  });
};

export const GetAllSynthExploreLinks = () => {
  return useQuery({
    queryKey: ["get-all-synth-explore-links"],
    queryFn: () => client.synthesis.getAllSynthExploreLinks(),
  });
};

export const CreateSynthExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.synthesis.newSynthExploreLink(data),
    onSuccess: () => {
      notify("Link added successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-synth-explore-links"] });
    },
    onError: () => notify("OOPS! something went wrong", "error"),
  });
};

export const UpdateSynthExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.synthesis.updateSynthExploreLink(data),
    onSuccess: () => {
      notify("Link updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-synth-explore-links"] });
    },
    onError: () => notify("OOPS! something went wrong", "error"),
  });
};

export const DeleteSynthExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.synthesis.deleteSynthExploreLink(data),
    onSuccess: () => {
      notify("Link deleted successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-all-synth-explore-links"] });
    },
    onError: () => notify("OOPS! something went wrong", "error"),
  });
};
